import React from "react";
import { Rocket } from "lucide-react";
import { Link } from "react-router-dom";
import { Layout, SectionContent } from "@layouts/MainLayout";

const ComingSoonPage: React.FC = () => {
  return (
    <Layout>
      <SectionContent>
        <div className="flex flex-col items-center justify-center h-screen bg-gray-100">
          <div className="bg-white p-8 rounded-lg shadow-lg text-center">
            <div className="flex justify-center mb-4">
              <Rocket size={50} className="mb-4" />
            </div>

            <h1 className="text-3xl font-semibold text-gray-700">
              Coming Soon
            </h1>

            <p className="mt-4 text-gray-600">
              <p className="text-gray-600 mb-4">
                This page is under development.
              </p>
              <Link to="/" className="text-blue-500 hover:text-blue-700">
                Go to Homepage
              </Link>
            </p>
          </div>
        </div>
      </SectionContent>
    </Layout>
  );
};

export default ComingSoonPage;
